import { render, staticRenderFns } from "./RewardEditor.vue?vue&type=template&id=6d5f6fd3&scoped=true"
import script from "./RewardEditor.vue?vue&type=script&lang=js"
export * from "./RewardEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5f6fd3",
  null
  
)

export default component.exports